import appConfig from 'app-config';
import useOpenLoginModalOnLandingPage from 'src/hooks/useOpenLoginModalOnLandingPage';
import { withTranslations } from 'src/i18n/static-generation';
import MatchView from 'src/views/Match';
import VividiLandingView from 'src/views/VividiLanding';
export const getStaticProps = withTranslations(() => ({
  props: {
    canonical: true,
    metas: [{
      property: 'og:title',
      content: 'OG_TITLE',
      key: 'og:title'
    }, {
      property: 'og:description',
      content: 'OG_DESC',
      key: 'og:description'
    }, {
      name: 'description',
      content: 'OG_DESC',
      key: 'description'
    }, {
      property: 'og:image',
      content: `/${appConfig.serviceCode}/images/og/openGraph.png`,
      key: 'og:image'
    }]
  }
}), {
  xDefaultRouteFn: () => ({
    pathname: '/'
  })
});
const AzarMatchPage = () => {
  useOpenLoginModalOnLandingPage();
  return <MatchView data-sentry-element="MatchView" data-sentry-component="AzarMatchPage" data-sentry-source-file="index.tsx" />;
};
const MatchPage = () => {
  if (appConfig.serviceCode === 'vividi') {
    return <VividiLandingView />;
  }
  return <AzarMatchPage data-sentry-element="AzarMatchPage" data-sentry-component="MatchPage" data-sentry-source-file="index.tsx" />;
};
export default MatchPage;